import { BaseEntity } from "./base-entity.model";
import { Type } from "@angular/core";
import { AngularFirestore, DocumentReference, QueryFn } from "@angular/fire/firestore";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

export class BaseEntityService<T extends BaseEntity> {
  constructor(
    protected db: AngularFirestore,
    protected type: Type<T>,
    protected basePath: string,
    protected collectionId: string
  ) { }

  log(method: string, data?: any) {
    console.log("firestore", method, (this.basePath || "") + this.collectionId, data);
  }

  ref(id: string): DocumentReference {
    return this.db
      .doc(this.basePath + this.collectionId + "/" + id).ref;
  }

  list(queryFn?: QueryFn): Observable<T[]> {
    const isCollectionGroupQuery = this.basePath === null;
    this.log("list " + (isCollectionGroupQuery ? "(collection group query)" : ""), queryFn);
    if (isCollectionGroupQuery) {
      return this.db.collectionGroup(this.collectionId, queryFn).get().pipe(map((querySnapshot) => querySnapshot.docs.map((doc) => new this.type(doc.data()))));
    } else {
      return this.db.collection(this.basePath + this.collectionId, queryFn).get().pipe(map((querySnapshot) => querySnapshot.docs.map((doc) => new this.type(doc.data()))));
    }
  }

  get(id: string): Observable<T> {
    this.log("get", id);
    return this.db
      .doc(this.basePath + this.collectionId + "/" + id)
      .valueChanges()
      .pipe(map(value => new this.type(value)));
  }

  exists(id: string): Observable<boolean> {
    this.log("exists", id);
    return this.db
      .doc(this.basePath + this.collectionId + "/" + id)
      .get()
      .pipe(
        map(doc => {
          return doc.exists;
        })
      );
  }

  update(entity: Partial<T>): Promise<void> {
    this.log("update", entity.id);
    const data = Object.assign({}, entity);
    return this.db.doc(this.basePath + this.collectionId + "/" + entity.id).update(data);
  }

  async create(entity: Partial<T>): Promise<void> {
    if (!entity.id) {
      entity.id = this.db.createId();
    }
    this.log("create", entity.id);
    const data = Object.assign({}, entity);
    return this.db.doc(this.basePath + this.collectionId + "/" + entity.id).set(data);
  }

  remove(entity: Partial<T>): Promise<void> {
    this.log("remove", entity.id);
    return this.db.doc(this.basePath + this.collectionId + "/" + entity.id).delete();
  }

}
